import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BUSINESS_INFO } from '../../constants/legal';

const Footer = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko';

  return (
    <footer className="landing-footer">
      <div className="wrap">
        <div className="footer-top">
          {/* Column 1: Brand */}
          <div>
            <div className="brand" style={{ marginBottom: 16 }}>
              <span className="font-headline font-extrabold text-white uppercase text-xl tracking-tight">VERIPASS</span>
            </div>
            <p>{isKo ? 'K-뷰티의 글로벌 진출을 위한 규제 검증 파트너' : 'Your regulatory validation partner for global K-beauty expansion'}</p>
            <p style={{ marginTop: 8 }}><a href="mailto:hello@whereat.kr">hello@whereat.kr</a></p>
          </div>
          {/* Column 2: Product */}
          <div>
            <h4>VeriPass</h4>
            <div className="footer-links">
              <a href="#features">{isKo ? '기능' : 'Features'}</a>
              <a href="#pricing">{isKo ? '가격' : 'Pricing'}</a>
              <a href="#faq">FAQ</a>
            </div>
          </div>
          {/* Column 3: Legal */}
          <div>
            <h4>Legal</h4>
            <div className="footer-links">
              <Link to="/about#terms">{isKo ? '이용약관' : 'Terms of Service'}</Link>
              <Link to="/about#privacy">{isKo ? '개인정보처리방침' : 'Privacy Policy'}</Link>
              <Link to="/about#refund">{isKo ? '환불정책' : 'Refund Policy'}</Link>
              <Link to="/about#ethics">{isKo ? '윤리 가이드라인' : 'Ethics Guidelines'}</Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          {/* 전자상거래법 제10조 disclosure -- 상호명 / 대표자명 / 사업자등록번호 /
              통신판매업 신고번호 / 소재지 / 연락처. EVERY field is read from
              constants/legal.js.
              It used to interpolate only bizRegNo and write the rest as string
              literals, which is how PrivacyPage ended up publishing a different
              address and a different romanisation of the same 대표자명. A second
              copy of a legally published value is a second value. */}
          <div className="biz">
            {isKo ? (
              <>
                <p>{BUSINESS_INFO.nameKo} | 대표 {BUSINESS_INFO.ceoKo} | 사업자등록번호: {BUSINESS_INFO.bizRegNo}</p>
                {/* T0.4 — 전자상거래법 제10조. The footer is where a Korean reviewer
                    looks for this first. The value is ECOMMERCE_FILING_NO in
                    constants/legal.js (supplied 2026-10-02); the guard stays so a
                    null can never print an empty label. */}
                {BUSINESS_INFO.ecommerceFilingNo && (
                  <p>통신판매업 신고번호: {BUSINESS_INFO.ecommerceFilingNo}</p>
                )}
                <p>주소 : {BUSINESS_INFO.addressKo}</p>
                <p>연락처 : {BUSINESS_INFO.tel}</p>
              </>
            ) : (
              <>
                <p>{BUSINESS_INFO.nameEn} | CEO {BUSINESS_INFO.ceoEn} | Business Reg. No. {BUSINESS_INFO.bizRegNo}</p>
                {BUSINESS_INFO.ecommerceFilingNo && (
                  <p>E-Commerce Filing No. {BUSINESS_INFO.ecommerceFilingNo}</p>
                )}
                <p>{BUSINESS_INFO.addressEn}</p>
                <p>Tel : {BUSINESS_INFO.tel}</p>
              </>
            )}
          </div>
          <div className="copyright">© 2026 VeriPass by WhereAt. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
